/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  SendEmail200,
  SendEmailBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Send an email with automatic company logo and optional document attachment. When a document_id is provided, a public shareable link is automatically generated and can be included in the email body using the {invoice_link} variable. If the variable is not used, the link is appended to the body. The PDF attachment is opt-in via attach_pdf flag (default: false). Email body supports markdown formatting and template variables like {document_number}, {customer_name}, {entity_name}, {invoice_link}, etc.
 * @summary Send email with optional PDF attachment
 */
export type sendEmailResponse200 = {
  data: SendEmail200
  status: 200
}

export type sendEmailResponse400 = {
  data: Error
  status: 400
}

export type sendEmailResponse401 = {
  data: Error
  status: 401
}

export type sendEmailResponse403 = {
  data: Error
  status: 403
}

export type sendEmailResponse404 = {
  data: Error
  status: 404
}

export type sendEmailResponse422 = {
  data: ValidationError
  status: 422
}

export type sendEmailResponse500 = {
  data: Error
  status: 500
}

export type sendEmailResponseSuccess = (sendEmailResponse200) & {
  headers: Headers;
};
export type sendEmailResponseError = (sendEmailResponse400 | sendEmailResponse401 | sendEmailResponse403 | sendEmailResponse404 | sendEmailResponse422 | sendEmailResponse500) & {
  headers: Headers;
};

export type sendEmailResponse = (sendEmailResponseSuccess | sendEmailResponseError)

export const getSendEmailUrl = () => {


  

  return `/email/send`
}

export const sendEmail = async (sendEmailBody: SendEmailBody, options?: RequestInit): Promise<sendEmailResponse> => {
  
  return customFetch<sendEmailResponse>(getSendEmailUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendEmailBody,)
  }
);}
  

